export const ABOUT_QUERY = `*[_type == "about"]{
    baseline,
    biography,
    clients,
    contact,
    slug,
    title,
}[0...50]`;